import Image from "next/image";
import Link from "next/link";
import { coverImageObjectPosition, coverImageSrc } from "@/lib/cover-image-meta";
import { formatDate, readingTime } from "@/lib/utils";
import { publicUserName } from "@/lib/user-display";
import type { WorldCupArticle } from "@/lib/world-cup-data";

export function WorldCupArticleCard({ article, compact = false }: { article: WorldCupArticle; compact?: boolean }) {
  const authorName = publicUserName(article.author);

  return (
    <Link href={`/article/${article.slug}`} className="group block rounded-md border border-[#E5DDD0] bg-white shadow-sm">
      <div className="relative aspect-[16/10] overflow-hidden rounded-t-md bg-[#EFE8DD]">
        {article.coverImage ? (
          <Image
            src={coverImageSrc(article.coverImage, article.coverImageMeta, compact ? "400" : "800")}
            alt={article.title}
            fill
            sizes={compact ? "(max-width: 768px) 100vw, 320px" : "(max-width: 768px) 100vw, 33vw"}
            className="object-cover transition duration-500 group-hover:scale-[1.03]"
            style={{ objectPosition: coverImageObjectPosition(article.coverImageMeta) }}
          />
        ) : null}
      </div>
      <div className="p-4">
        <p className="text-[10px] font-black uppercase tracking-[0.2em] text-[#A4243B]">
          {article.category.name}
        </p>
        <h3 className="mt-2 line-clamp-3 font-sans text-lg font-black leading-tight text-[#111111] group-hover:underline">
          {article.title}
        </h3>
        {!compact ? (
          <p className="mt-2 line-clamp-2 text-sm leading-6 text-[#6B6B6B]">{article.excerpt}</p>
        ) : null}
        <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.16em] text-[#8B8175]">
          {authorName} / {formatDate(article.publishedAt)} / {readingTime(article.content)} perc
        </p>
      </div>
    </Link>
  );
}
